export default __webpack_public_path__ + "static/media/ribbin2.087d2120.png";